<template>
	<div>
		<tabs-component :tabs="tabs"></tabs-component>
		<router-view></router-view>
	</div>
</template>

<script>
	import TabsComponent from '@/components/shared/TabsComponent';

	export default {
		components: {
			TabsComponent,
		},
		data() {
			return {
				tabs: [
					{
						id: 1,
						title: 'Company',
						link: { name: 'company' },
					},
					{
						id: 2,
						title: 'Subsidiaries',
						link: { name: 'subsidiaries' },
					},
				],
			};
		},
		name: 'configuration',
	};
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// Configuration.vue?68522cd8